//
//
//
//
//
//
//
//
//
//
//

import LazyLoader from '@/components/ui/LazyLoader'
import NoResults from '@/components/client/NoResults'
import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'FreelancerFeedbacks',
  components: {
    LazyLoader,
    NoResults
  },
  mixins: [AxiosErrorHandler],
  props: {
    freelancerId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      feedbacks: [],
      loading: false
    }
  },
  computed: {
    validFeedbacks () {
      return this.feedbacks.filter(f => f.clientFeedback)
    }
  },
  async mounted () {
    try {
      this.loading = true
      const { data } = await this.$axios.get(`/freelancers/${this.freelancerId}/feedbacks`)
      this.feedbacks = data.data || []
      this.loading = false
    } catch (err) {
      this.loading = false
      await this.handleError(err)
    }
  }
}
